import { memo, useState } from 'react'
import Field from './Field'
import InputFieldSkeleton from './InputFieldSkeleton'
import { CRRender } from '../../crRender'
import { CheckArabicText, CheckEnglishText } from '@/utils'
import { errorToast } from '@/utils/toasters'


const InputField = ({ isLoading, name, formHandler, isRequired = true, isDisabled = false, type = "text", className = "col-md-6", defaultValue, min, step, lang = "Ar" }) => {
    const { formValues, handleFormValues } = formHandler

    const [inputClassNAme, setClassName] = useState("")


    const handleValue = (val) => {
        handleFormValues(name, val)
        if (lang == "Ar" && val?.value != "") {
            if (CheckArabicText(val?.value)) {
                setClassName("")
            } else {
                setClassName("value-error")
            }
        }
        if (lang == "En" && val?.value != "") {
            if (CheckEnglishText(val?.value)) {
                setClassName("")
            } else {
                setClassName("value-error")
            }
        }
    }

    return (
        <>
            <InputFieldSkeleton isRender={isLoading} className={className} />
            <CRRender isRender={!isLoading}>
                <Field
                    className={`${className} ${inputClassNAme}`}
                    label={name}
                    type={type}
                    defaultValue={defaultValue}
                    isRequired={isRequired}
                    lang={lang}
                    disabled={isDisabled}
                    value={formValues[name]}
                    setValue={val => handleValue(val)}
                    min={min}
                    step={step} />
            </CRRender>
        </>
    )

}

export default memo(InputField)